export default __webpack_public_path__ + "static/park-pedregal-amenidades-07-roof-asoleadero-15f48144be9361797d1ff3128e58065b.jpg";